import loadable from "@loadable/component";
export const AdminDashboard = loadable(() => import("./AdminDashboard"));
